import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FormInput from './input';

class Options extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: { ...props.options }
    };

    this.handleValuesChange = this.handleValuesChange.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    const { options: currentStateOptions } = this.state;
    const currentTimeFilterStart = (currentStateOptions && currentStateOptions.timeFilterStart) ? currentStateOptions.timeFilterStart : null;
    const currentTimeFilterEnd = (currentStateOptions && currentStateOptions.timeFilterEnd) ? currentStateOptions.timeFilterEnd : null;
    const { options } = this.props;
    const optionsChanged = !_.isEqual(options, nextProps.options) && !_.isEqual(currentStateOptions, nextProps.options);
    if (optionsChanged) {
      this.setState({
        options: {
          ...nextProps.options,
          // don't set state for timeline filters, current state is the source of truth
          timeFilterStart: nextProps.options.timeFilterStart !== null ? nextProps.options.timeFilterStart : currentTimeFilterStart,
          timeFilterEnd: nextProps.options.timeFilterEnd !== null ? nextProps.options.timeFilterEnd : currentTimeFilterEnd
        }
      });
      return true;
    }
    return false;
  }

  handleValuesChange(values) {
    const { onUpdate } = this.props;
    this.setState(prevState => ({
      options: { ...prevState.options, ...values }
    }), () => {
      const { options } = this.state;
      onUpdate(options);
    });
  }

  render() {
    const { canAdmin, optionFields } = this.props;
    const { options } = this.state;
    const readonly = {
      activityCreateCount: !canAdmin,
      activityHoursBetween: !canAdmin,
      timelineMaxDays: !canAdmin,
      timelineSnapMinutes: !canAdmin,
      rosterPivot: false,
      hideEmptyRows: !canAdmin,
      assignmentTitleFormat: false,
      timeFilter: false,
      displayTravelLayer: false,
      displayLeaveLayer: false,
      displayAvailabilityLayer: false,
      hideUnallocatedRows: !canAdmin
    };
    return (
      <div className="bhp-timeline-options-form">
        <div className="bhp-form">
          <FormInput readonly={readonly} dataSource={options} optionFields={optionFields} onValuesChange={this.handleValuesChange} />
        </div>
      </div>
    );
  }
}

Options.propTypes = {
  canAdmin: PropTypes.bool,
  options: PropTypes.object,
  optionFields: PropTypes.object,
  onUpdate: PropTypes.func
};

Options.defaultProps = {
  canAdmin: false,
  options: {
    activityCreateCount: 1,
    activityHoursBetween: 24,
    timelineMaxDays: 120,
    timelineSnapMinutes: 60,
    displayTravelLayer: false,
    displayLeaveLayer: false,
    displayAvailabilityLayer: false,
    rosterPivoted: false,
    hideEmptyRows: false,
    assignmentTitleFormat: '',
    hideUnallocatedRows: false
  },
  optionFields: {
    showActivityCreateCount: true,
    showActivityHoursBetween: true,
    showTimelineMaxDays: true,
    showTimelineSnapMinutes: true,
    showDisplayTravelLayer: true,
    showDisplayLeaveLayer: false,
    showDisplayAvailabilityLayer: false,
    showRosterPivot: true,
    showHideEmptyRows: true,
    showAssignmentTitleFormat: true,
    showTimeFilter: true,
    showHideUnallocatedRows: true
  },
  onUpdate() {
  }
};

export default Options;
